import { type FC } from 'react';
import RegisterForm from '@/components/auth/RegisterForm';

export const RegisterPage: FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 'var(--spacing-lg)',
      }}
    >
      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
